import React, { useState, useContext } from "react";
import { Context } from "../store/appContext";
import getApiBaseUrl from "../utils/api";

const API_URL = getApiBaseUrl();

const AddMonthlyInventoryData = () => {
  const { actions } = useContext(Context);
  const [checked, setChecked] = useState(false);

  const [formData, setFormData] = useState({
    year: "",
    month: "",
    inventory_value: "",
    entries_value: "",
    exits_value: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const { year, month, entries_value, exits_value, inventory_value } =
      formData;

    if (!year || !month) {
      actions.showToast("Año y mes son obligatorios", "warning");
      return false;
    }

    if (
      (entries_value && Number(entries_value) < 0) ||
      (exits_value && Number(exits_value) < 0) ||
      (inventory_value && Number(inventory_value) < 0)
    ) {
      actions.showToast("No se permiten valores negativos", "warning");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const token = localStorage.getItem("token");

    if (!token) {
      actions.showToast("Sesión no válida. Vuelve a iniciar sesión.", "error");
      return;
    }

    setLoading(true);

    const payload = {
      year: Number(formData.year),
      month: Number(formData.month),
      entries_value: formData.entries_value
        ? Number(formData.entries_value)
        : 0,
      exits_value: formData.exits_value ? Number(formData.exits_value) : 0,
    };

    if (formData.inventory_value !== "") {
      payload.inventory_value = Number(formData.inventory_value);
    }

    try {
      const response = await fetch(`${API_URL}/api/kpis/inventory-value`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const error = await actions.handleApiError(response);
      if (error) {
        setLoading(false);
        return;
      }

      await actions.getDashboard();
      await actions.getInventoryHistory();

      setFormData({
        year: "",
        month: "",
        inventory_value: "",
        entries_value: "",
        exits_value: "",
      });

      setChecked(false);
      actions.showToast("Datos guardados correctamente", "success");
    } catch (error) {
      console.error(error);
      actions.showToast("Error al guardar datos", "error");
    }

    setLoading(false);
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="mb-4 text-center">
                Registro mensual de inventario
              </h4>

              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Año</label>
                    <select
                      className="form-control"
                      name="year"
                      value={formData.year}
                      onChange={handleChange}
                    >
                      <option value="">Seleccionar</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Mes</label>
                    <select
                      className="form-control"
                      name="month"
                      value={formData.month}
                      onChange={handleChange}
                    >
                      <option value="">Seleccionar</option>
                      <option value="1">Enero</option>
                      <option value="2">Febrero</option>
                      <option value="3">Marzo</option>
                      <option value="4">Abril</option>
                      <option value="5">Mayo</option>
                      <option value="6">Junio</option>
                      <option value="7">Julio</option>
                      <option value="8">Agosto</option>
                      <option value="9">Septiembre</option>
                      <option value="10">Octubre</option>
                      <option value="11">Noviembre</option>
                      <option value="12">Diciembre</option>
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Valor total del inventario (€)
                  </label>

                  <div style={{ marginBottom: "8px" }}>
                    <label style={{ fontSize: "13px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                        style={{ marginRight: "6px" }}
                      />
                      Introducir valor manualmente
                    </label>
                  </div>

                  <input
                    type="number"
                    disabled={!checked}
                    className="form-control"
                    name="inventory_value"
                    placeholder={
                      checked
                        ? "Introduce el valor del inventario"
                        : "Se calculará automáticamente"
                    }
                    value={formData.inventory_value}
                    onChange={handleChange}
                  />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Entradas (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="entries_value"
                      placeholder="Compras / entradas"
                      value={formData.entries_value}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Salidas (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="exits_value"
                      placeholder="Consumos / salidas"
                      value={formData.exits_value}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="d-grid mt-3">
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Guardando..." : "Guardar datos"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMonthlyInventoryData;
